/**
 * Currently used for portfolio and AI Report
 */
export enum ResourceLoadingFailReason {
  NotFound = 'NotFound',
  NetworkError = 'NetworkError',
  Other = 'Other',
}
